module.exports = __webpack_public_path__ + "img/HoverFeedbackGood.c093b4cc.png";